'use strict';

module.exports = /* @ngInject */ function ($mdToast) {

	function showNotification(msg, type, timeout){
		$mdToast.show({
			template: '<md-toast class="md-toast-' + type + '">' + msg + '</md-toast>',
			hideDelay: timeout,
			position: 'bottom left'
		});
	}

	return {
		showErrorNotification: function (msg, timeout=5000){showNotification(msg, 'danger', timeout);},
		showWarningNotification: function (msg, timeout=5000){showNotification(msg, 'warning', timeout);},
		showSuccessNotification: function (msg, timeout=5000){showNotification(msg, 'success', timeout);},
		showInfoNotification: function (msg, timeout=5000){showNotification(msg, 'info', timeout);},
		showPrimaryNotification: function (msg, timeout=5000){showNotification(msg, 'primary', timeout);},
		showSecondaryNotification: function (msg, timeout=5000){showNotification(msg, 'secondary', timeout);},
	};
}
